// donorSaga.js

import { all, fork, put, call, takeLatest } from 'redux-saga/effects';
import { donorAction } from './donorSlice';
import * as donorApiLib from '../lib/donorApi';
import * as storageApiLib from '../lib/storageApi';

function* list({ payload }) {
  try {
    const donorList = yield call(donorApiLib.listDonors, payload);
    yield put(donorAction.listSuccess(donorList));
  } catch (error) {
    yield put(donorAction.listFailure(error.message));
  }
}

function* donorOfDonationlist({ payload }) {
  try {
    const donationList = yield call(donorApiLib.listDonorOfDonation, payload);
    yield put(donorAction.donorOfDonationListSuccess(donationList));
  } catch (error) {
    yield put(donorAction.donorOfDonationListFailure(error.message));
  }
}

function* detail({ payload }) {
  try {
    const donorInfo = yield call(donorApiLib.detailDonors, payload);

    yield put(donorAction.detailSuccess({ donorInfo }));
  } catch (error) {
    yield put(donorAction.detailFailure({ error }));
  }
}

function* add({ payload }) {
  try {
    const placeId = payload.placeId;
    const donorFileList = payload.donorFileList;
    const formValue = payload.formValue;
    const handleUploadProgress = payload.handleUploadProgress;

    const resultDonorFileList = yield call(storageApiLib.upload, {
      fileList: donorFileList,
      placeId,
      handleUploadProgress,
    });

    yield call(donorApiLib.addDonors, {
      ...formValue,
      placeId,
      donorFileList: resultDonorFileList,
    });

    yield put(donorAction.addSuccess());
  } catch (error) {
    yield put(donorAction.addFailure({ error }));
  }
}

function* update({ payload }) {
  try {
    const formValue = payload.formValue;
    const placeId = payload.placeId;
    const donorFileList = payload.donorFileList;
    const addDonorFileList = payload.addDonorFileList;
    const removeDonorFileList = payload.removeDonorFileList;
    const handleUploadProgress = payload.handleUploadProgress;

    const resultDonorFileList = yield call(storageApiLib.uploadAndRemove, {
      addFileList: addDonorFileList,
      removeFileList: removeDonorFileList,
      fileList: donorFileList,
      placeId: placeId,
      handleUploadProgress,
    });

    // donorFileList를 updateInfo 안으로 포함시킴
    const updatedFormValue = {
      donorId: formValue.donorId,
      updateInfo: {
        ...formValue.updateInfo,
        donorFileList: resultDonorFileList,
      },
    };

    // 서버 호출
    yield call(donorApiLib.updateDonors, updatedFormValue);

    yield put(donorAction.updateSuccess());
  } catch (error) {
    console.error('UPDATE saga error:', error);
    yield put(donorAction.updateFailure({ error }));
  }
}

function* remove({ payload }) {
  try {
    let callList = [];
    let donorIdList = [];
    let removeFilePathList = [];

    for (const donorInfo of payload.donorIdList) {
      donorIdList.push(donorInfo.donorId);
      const fileListInfo = donorInfo.donorFileList;

      for (const file of fileListInfo) {
        removeFilePathList.push(file.filePath);
        if (file.thumbFilePath) {
          removeFilePathList.push(file.thumbFilePath);
        }
      }
    }

    yield call(storageApiLib.remove, { filePathList: removeFilePathList });
    yield all([...callList]);
    yield call(donorApiLib.removeDonors, { donorIdList: donorIdList });

    yield put(donorAction.removeSuccess());
  } catch (error) {
    yield put(donorAction.removeFailure({ error }));
  }
}

export function* watchList() {
  yield takeLatest(donorAction.list.type, list);
}

export function* watchDonorOfDonationList() {
  yield takeLatest(donorAction.donorOfDonationList.type, donorOfDonationlist);
}

export function* watchDetail() {
  yield takeLatest(donorAction.detail, detail);
}

export function* watchUpdate() {
  yield takeLatest(donorAction.update, update);
}

export function* watchAdd() {
  yield takeLatest(donorAction.add, add);
}

export function* watchRemove() {
  yield takeLatest(donorAction.remove, remove);
}

function* rootSaga() {
  yield all([
    fork(watchList),
    fork(watchDonorOfDonationList),
    fork(watchAdd),
    fork(watchDetail),
    fork(watchUpdate),
    fork(watchRemove),
  ]);
}

export default rootSaga;
